"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ifOnly = _interopRequireDefault(require("if-only"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = function className(props) {
  return (0, _classnames.default)('Label', {
    'Label--with-errors': props.error != null
  });
};

var Label = function Label(props) {
  var children = props.children,
      required = props.required,
      style = props.style;
  return _react.default.createElement("label", {
    className: className(props),
    style: style
  }, _react.default.createElement("span", null, children), required ? _react.default.createElement("span", {
    style: {
      color: '#FF7F93'
    }
  }, " *") : void 0);
};

var _default = Label;
exports.default = _default;